import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Link } from '@mui/material';
import AuthLayout from '../../components/auth/AuthLayout';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const { resetPassword } = useAuth();
    const navigate = useNavigate();
    const { showNotification } = useNotification();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await resetPassword(email);
            showNotification(
                'パスワードリセットのメールを送信しました。メールをご確認ください。',
                'success'
            );
            navigate('/login');
        } catch (error) {
            showNotification(
                'パスワードリセットメールの送信に失敗しました。メールアドレスを確認してください。',
                'error'
            );
        }
    };

    return (
        <AuthLayout>
            <Typography
                variant="h5"
                component="h1"
                align="center"
                sx={{
                    fontSize: '1.2rem',
                    fontWeight: 500,
                    mb: 1
                }}
            >
                パスワードをお忘れの方
            </Typography>
            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                }}
            >
                <TextField
                    required
                    fullWidth
                    id="email"
                    label="メールアドレス"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="small"
                    margin="none"
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    size="small"
                >
                    パスワードリセットメールを送信
                </Button>
                <Link
                    href="/login"
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        textDecoration: 'none',
                        fontSize: '0.875rem',
                        textAlign: 'center',
                        mt: 1,
                        '&:hover': {
                            textDecoration: 'underline'
                        }
                    }}
                >
                    ログイン画面に戻る
                </Link>
            </Box>
        </AuthLayout>
    );
}

export default ForgotPassword; 